import { mixins, styled } from '@bob/library'

export const SwimlanesContainer = styled.div`
  ${mixins.media.max.desktop} {
    display: none;
  }
`

export const Row = styled.div`
  display: flex;
  position: relative;
  gap: 20px;
  & > * {
    flex: 1;
  }
`

export const GradeBand = styled.div`
  border-top: 4px dotted #d9d9d9;
  position: absolute;
  width: 98vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
`
